import { isContourName, isStreamName } from '../hooks/useLayerTypeDetection';
// Base URL of the public layer guide. Each section on that page exposes an
// HTML anchor id, so a layer's "?" deep-links straight to its explanation.
// Absolute on purpose: the viewer may be served from a different host than the
// marketing site that hosts /learn.
export const LEARN_GUIDE_BASE_URL = 'https://landscope.earth/learn';
const LEARN_ANCHOR_BY_KIND = {
    elevation: 'elevation',
    hillshade: 'hillshade',
    contours: 'contours',
    slope: 'slope',
    aspect: 'aspect',
    twi: 'twi',
    'flow-accumulation': 'flow-accumulation',
    'drainage-network': 'drainage-network',
    geomorphons: 'geomorphons',
};
// Classify an artifact into a layer kind from its name (and metadata, which the
// shared stream detector also consults). Ordered most-specific first so layers
// whose names overlap a broader keyword resolve correctly — e.g. a colored
// hillshade must match 'hillshade' before any 'elevation' fallback, and a
// drainage layer must match before generic hydrology terms.
const detectLayerKind = (name, metadataJson) => {
    const n = name.toLowerCase();
    if (n.includes('aspect'))
        return 'aspect';
    if (n.includes('slope'))
        return 'slope';
    if (n.includes('geomorphon'))
        return 'geomorphons';
    if (n.includes('hillshade'))
        return 'hillshade';
    if (isContourName(name))
        return 'contours';
    if (n.includes('twi') || n.includes('wetness'))
        return 'twi';
    if (n.includes('flow') && n.includes('accum'))
        return 'flow-accumulation';
    if (n.includes('drainage') || isStreamName(name, metadataJson))
        return 'drainage-network';
    if (n.includes('elevation'))
        return 'elevation';
    return null;
};
// Resolve the /learn deep link for an artifact, or null when the layer has no
// matching guide section (callers should then render no "?").
export const getLearnLinkForArtifact = (name, metadataJson = '') => {
    const kind = detectLayerKind(name, metadataJson);
    if (!kind)
        return null;
    return `${LEARN_GUIDE_BASE_URL}#${LEARN_ANCHOR_BY_KIND[kind]}`;
};
